import { type FieldGroupEnum, type OrderDocumentRevision, OrderType } from "@/graphql/codegen/graphql"

interface GetOrderDocumentNameParams {
  orderType: OrderType
  externalSystemId?: string | null
  orderId: number
  suffix?: string
}

const OrderTypePrefixMap: Record<OrderType, string> = {
  [OrderType.PurchaseOrder]: "PO",
  [OrderType.Quote]: "Q",
  [OrderType.SalesOrder]: "SO", // Use correct once implemented
}

export const getOrderDocumentName = ({
  orderType,
  externalSystemId,
  orderId,
  suffix,
}: GetOrderDocumentNameParams): string => {
  const prefix = OrderTypePrefixMap[orderType]
  const identifier = externalSystemId?.split("_")[0] ?? orderId
  const parts = [prefix, identifier]

  if (suffix) {
    parts.push(suffix)
  }

  return `${parts.join("-")}.pdf`
}

export const getDocumentRevisionSuffix = ({
  fieldGroup,
  orderType,
  documentRevisions,
}: {
  fieldGroup?: FieldGroupEnum
  orderType: OrderType
  documentRevisions: OrderDocumentRevision[]
}): string => {
  if (!fieldGroup) {
    return ""
  }

  const revisionsCount = documentRevisions.filter(({ revision }) =>
    revision.includes(`-${OrderTypePrefixMap[orderType]}`)
  )?.length

  return `Rev${(revisionsCount + 1).toString().padStart(2, "0")}`
}
